import * as React from 'react'
import { Profile, pushState } from 'DVWebNodeUtils'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import { Tooltip } from '@amzn/dvui/dist/Tooltip'
import { NavProfiles } from '../transforms/Profiles'
import * as cn from 'classnames'

export const ProfilesMenu = (profiles: NavProfiles) => (
<>
    <li className="profile-item nav-profiles-menu-active-profile">
      <div style={{ backgroundImage: `url(${profiles.activeProfile.avatarUrl})` }} className="profile-avatar" />
      {profiles.activeProfile.name}
    </li> 
    {profiles.otherProfiles.map((profile: Profile, index: number) =>
      <form className="profile-item" id={`profile-${index}`} action={profile.switchLink.partialURL} method="POST">
          <input className="profile-input-submit" type="submit" id={`input-profile-${index}`} name={`input-profile-${index}`} />
          <label htmlFor={`input-profile-${index}`}> 
            <li>
              <div style={{ backgroundImage: `url(${profile.avatarUrl})` }} className="profile-avatar" />
              {profile.name}
            </li> 
          </label>
        {Object.keys(profile.switchLink.query).map((name) => (
          <input type="hidden" name={name} value={profile.switchLink.query[name]}/>
        ))}
      </form>)}
    {profiles.canCreate && profiles.links.createProfileNav ? 
        <li className="profile-item add-new">
          <a href={profiles.links.createProfileNav} >
          <div className="profile-avatar" />
            {profiles.strings.DV_PROFILES_MANAGE_ADD_NEW}</a>
        </li>
    : null}
    <li id="manage-profiles"> 
      <a href={profiles.links.manageProfile} className="nav-profiles-menu-link">{profiles.strings.DV_PROFILES_MANAGE}</a>
    </li>
    <li><a href={profiles.links.learnMore} className="nav-profiles-menu-link"> {profiles.strings.DV_PROFILES_LEARNMORE}</a> </li>
  </>
)

const getProfilesTooltipContent = (profiles: NavProfiles) => {
  switch (profiles.tooltipType) {
    case 'INTRO': 
      return (
        <>
          <span className="nav-profiles-tooltip-content nav-profiles-tooltip-heading"> {profiles.strings.DV_PROFILES_INTRO_HEADING} </span>
          <span className="nav-profiles-tooltip-content nav-profiles-tooltip-text"> {profiles.strings.DV_PROFILES_INTRO_TEXT} </span>
          <span className="nav-profiles-tooltip-content nav-profiles-tooltip-link"> 
            <a href={profiles.links.learnMore} onClick={(e) => {e.stopPropagation()}}> {profiles.strings.DV_PROFILES_INTRO_LINK} </a> 
          </span>
        </>
      )
      break;
    case 'ERROR': 
      return (
        <>
          <span className="nav-profiles-tooltip-text"> {profiles.message} </span>
        </>
      )
      break;
    case 'SWITCH_FAIL': 
    return (
      <>
        <span className="nav-profiles-tooltip-text"> {profiles.strings.DV_PROFILES_GETCONTEXT_SWITCHING} </span>
      </>
    )
    break;
  }
}

const getProfilesTooltipUse = (profiles: NavProfiles) => {
  switch (profiles.tooltipType) {
    case 'INTRO' :
      return 'info'
      break;
    case 'ERROR' :
      return 'error'
      break;
    case 'SWITCH_FAIL' :
      return 'error'
      break
  }
}

export class ProfilesDropdown extends React.Component<NavProfiles> {
  constructor(props: NavProfiles) {
    super(props)
  }

  profilesDropdownCheckbox: HTMLInputElement

  componentDidMount() {
    if (window && window.history) {
      const url = new URL(window.location.href)
      url.searchParams.delete('switchSuccess')
      pushState(null, document.title, url.href)
    }
  }

  render () {
    return (
      <>
        <input type="checkbox" className="nav-profiles-dropdown"
          name="nav-menu" id="nav-profiles-dropdown" defaultChecked={false}
          ref={input => this.profilesDropdownCheckbox = input} />
        <label id="nav-profiles-dropdown-label"
          htmlFor="nav-profiles-dropdown" className={cn("pv-nav-dropl__label", {'pv-nav-error-label': this.props.tooltipType == 'ERROR'})}>
          {this.props.tooltipType ? 
            <span onClick={() => this.profilesDropdownCheckbox.checked = !this.profilesDropdownCheckbox.checked}>
              <Tooltip startOpen dismissable size={'m'} position={'bottom'} 
                content={getProfilesTooltipContent(this.props)}
                use={getProfilesTooltipUse(this.props)}
                className={`nav-profiles-tooltip nav-profiles-tooltip-${this.props.tooltipType.toLowerCase()}`}>
              </Tooltip>
            </span>
            : 
            <></>
          }
          {this.props.tooltipType == 'ERROR' ? <Icon use={IconType.ALERT_CRITICAL_BLOCK} className="profile-avatar profile-error" />
          : <div style={{ backgroundImage: `url(${this.props.activeProfile.avatarUrl})` }} className="profile-avatar" />
          }
          <div className="label-content">
            <span className="profiles-dropdown-whos-watching">{this.props.strings.DV_PROFILES_WW}</span>
            <span className="profiles-dropdown-name">
              {this.props.activeProfile ? this.props.activeProfile.name : ''}</span>
          </div>
        </label>    
      </>
    )
  }
}
